// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"36311c10","511":"e9ff5e79","598":"f9ebffbf"}[chunkId] + ".chunk.js";
};